import { useEffect, useMemo } from 'react';

import { APP_PRODUCT_TYPE } from 'appConstants';
import { useMetadata } from 'contexts/Metadata';
import SingleSelectField from 'fields/SingleSelectField';

import type { IPaymentTermsField } from './types';

const PaymentTermsField = ({
  disabled,
  name,
  label,
  placeholder,
  productType = APP_PRODUCT_TYPE.FERTILISER,
  required,
  applyFor,
}: IPaymentTermsField) => {
  const {
    state,
    state: { paymentTermsLoadedProductType, paymentTermsLoading, paymentTermsError },
    actions: { loadPaymentTerms },
    selectors: { selectFilteredPaymentTerms },
  } = useMetadata();

  const shouldLoadPaymentTerms =
    (!paymentTermsLoadedProductType || paymentTermsLoadedProductType !== productType) &&
    !paymentTermsLoading &&
    !paymentTermsError;

  useEffect(() => {
    if (shouldLoadPaymentTerms) {
      loadPaymentTerms(productType);
    }
  }, [loadPaymentTerms, productType, shouldLoadPaymentTerms]);

  const paymentTerms = useMemo(() => {
    return selectFilteredPaymentTerms(state, applyFor);
  }, [selectFilteredPaymentTerms, state, applyFor]);

  const options = useMemo(
    () =>
      paymentTerms.map(({ paymentDescription, paymentTermsCode }) => ({
        value: paymentTermsCode,
        label: paymentDescription,
      })),
    [paymentTerms],
  );

  return (
    <SingleSelectField
      required={required}
      data-testid="payment-terms-field"
      loading={paymentTermsLoading}
      disabled={disabled}
      name={name}
      label={label}
      placeholder={placeholder}
      options={options}
    />
  );
};
export default PaymentTermsField;
